export default __webpack_public_path__ + "static/media/kitchen5-afterC-480w.722b3b93.png";